import {connect} from 'react-redux';
import PriceWrapper from '../components/shared/currency/price-wrapper';

const mapStateToProps = (state) => {
  return {
    selectedCurrency: state.store.selectedCurrency
  };
};

export default connect(mapStateToProps)(PriceWrapper);



// WEBPACK FOOTER //
// ./src/containers/price-wrapper.js